import { createContext, useContext } from 'react';
import { AccountInfo } from '../models/account';
import { AccountBindResponse, EmailIdentityRequest, IdentityLoginToken, JwtToken, VerifyIdentityRequest } from '../models/auth';
import { LinkInfo } from '../models/link';
import { InvoiceInfo, PayHistoryInfo, PayType } from '../models/payment';
import { PlatformCard } from '../models/platform';
import { ResultResponse } from '../models/result';
import { ServerInfo } from '../models/servers';
import { CheckSubscriptionResult, Subscription } from '../models/subscriptions';
import { TelegramProxyLink } from '../models/tgProxy';

export interface IRestClient {
  checkSubscription: () => Promise<CheckSubscriptionResult>;
  createSubscription: (ref?: string) => Promise<ResultResponse<Subscription>>;
  getPlatforms: () => Promise<ResultResponse<PlatformCard[]>>;
  getPayTypes: () => Promise<PayType[]>;
  termOfUse: () => Promise<ResultResponse<string>>;
  getServers: () => Promise<ServerInfo[]>;
  getServersInternal: () => Promise<ServerInfo[]>;
  getLink: () => Promise<LinkInfo>;
  getTelegramProxyLinks: () => Promise<TelegramProxyLink[]>;
  getPayHistory: (page: number, size: number, type: string[]) => Promise<PayHistoryInfo[]>;
  createInvoice: (type: string) => Promise<InvoiceInfo>;
  fetchTgPaymentLink: (type: string) => Promise<LinkInfo>;
  getReferralHash: () => Promise<ResultResponse<string>>;
  getReferralsCount: () => Promise<ResultResponse<number>>;
  happCrypto: (url: string) => Promise<ResultResponse<string>>;
  bindEmail: (request: EmailIdentityRequest) => Promise<ResultResponse<AccountBindResponse>>;
  verifyEmailBinding: (request: VerifyIdentityRequest) => Promise<ResultResponse<void>>;
  loginByEmail: (request: EmailIdentityRequest) => Promise<IdentityLoginToken>;
  verifyEmailLogin: (request: VerifyIdentityRequest) => Promise<JwtToken>;
  getAccountInfo: () => Promise<ResultResponse<AccountInfo>>;
}

export const RestClientContext = createContext<IRestClient | null>(null);

export const useRestClient = (): IRestClient => {
  const client = useContext(RestClientContext);
  if (!client) throw new Error('RestClient is not provided');
  return client;
};
